import { ArrowRightOutlined } from '@ant-design/icons'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './seq-label-list.module.scss'
import { DuLabel } from '../../../../../entities/du-labels/types/du-label.types'

type SeqLabelListProps = {
  labels: DuLabel[]
  selectedLabel: DuLabel | null
  onCheck: (label: DuLabel) => void
}

export const SeqLabelList = ({ labels, onCheck, selectedLabel }: SeqLabelListProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(styles.wrapper, 'pt-3 px-2')}>
      <h6 className={clsx('text-center')}>{t('milestoneSequence.duCheckHeader')}</h6>

      <div className={clsx('d-flex flex-column p-3')}>
        {labels.map((label) => (
          <div
            key={`label_${label.id}`}
            className={clsx(styles.labelItem, {
              [styles.labelItemActive]: selectedLabel?.id === label.id,
            })}
            onClick={() => onCheck(label)}
          >
            {label.name}
            <div>
              <ArrowRightOutlined />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
